import React, { Fragment } from 'react';
import Paper from '@material-ui/core/Paper';
import Divider from '@material-ui/core/Divider';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Breadcrumbs from './Breadcrumbs';
import { isMobile } from 'react-device-detect';

const useStyles = makeStyles((theme) => ({
  fullCard: {
    padding: isMobile ? 0 : theme.spacing(2),
    border: isMobile ? 0 : 1,
    background: isMobile ? 'unset' : '#fff',
  },
  header: {
    display: 'flex',
    flexFlow: 'row nowrap',
    justifyContent: 'space-between',
  },
  title: {
    display: 'flex',
    flexDirection: 'column',
    '& > div': {
      marginBottom: theme.spacing(1),
    },
  },
  headerTitle: {},
  headerDescription: {
    color: theme.palette.secondary.light,
    marginTop: theme.spacing(0.5),
  },
  body: {},
  divider: {
    margin: theme.spacing(1, 0),
  },
  actions: {
    flexGrow: 1,
    display: 'flex',
    flexFlow: 'row wrap',
    alignItems: 'center',
    justifyContent: 'flex-end',
    '& > button': {
      margin: theme.spacing(0, 0.5),
    },
  },
}));
const FullCard = ({
  title,
  category,
  children,
  actions,
  className = '',
  divider = true,
  paper = true,
}) => {
  const classes = useStyles();
  return (
    <Fragment>
      <Breadcrumbs title={title} />
      <Paper
        variant={isMobile ? 'outlined' : 'elevation'}
        className={classes.fullCard + ` ${className && className}`}
      >
        <div className={classes.header}>
          <div className={classes.title}>
            {title ? (
              <Typography
                className={classes.headerTitle}
                component="h1"
                variant="h1"
              >
                {title}
              </Typography>
            ) : null}
            {category ? (
              <div className={classes.headerDescription}>{category}</div>
            ) : null}
          </div>
          <div className={classes.actions}>{actions}</div>
        </div>
        {divider && <Divider className={classes.divider} />}
        <div className={classes.body}>{children}</div>
      </Paper>
    </Fragment>
  );
};
export default FullCard;
